import { useContext, useEffect, useState } from "react";
import { config } from "../../../../constant";
import { useElement, useLocale, useService } from "../../../../hooks";
import { AppContext, NavigatorContext } from "../../../../context";

export const useCampaignList = () => {
  const { t } = useLocale();
  const Actor = useElement("Actor");
  const CheckBox = useElement("CheckBox");
  const Img = useElement("Img");
  const { save, fetchAll, remove } = useService("Data", "campaign");
  const { setTitle } = useService("Meta");
  const { actions: { showPreloader, hidePreloader } } = useContext(AppContext);
  const { generateUID, isBottom, showAlert } = useService("Misc");
  const { navigateTo } = useContext(NavigatorContext);
  const { commonPageSize } = config;
  const [tableContent, settableContent] = useState(null);
  const [activeShownTotal, setactiveShownTotal] =
    useState<number>(commonPageSize);
  const [tableData, settableData] = useState([]);
  const [activeItem, setactiveItem] = useState(null);
  const [filteredList, setfilteredList] = useState([]);
  const [showTrashConfirm, setshowTrashConfirm] = useState<boolean>(false);
  const [isMultipleDelete, setisMultipleDelete] = useState<boolean>(false);
  const [checkedList, setcheckedList] = useState([]);
  const [checkedAll, setcheckedAll] = useState<boolean>(false);

  const trackScrolling = () => {
    const wrappedElement = document.getElementById("list-wrapper");
    if (isBottom(wrappedElement)) {
      if (
        filteredList.length > commonPageSize &&
        activeShownTotal < filteredList.length
      )
        showMore();
    }
  };

  const showMore = () => {
    showPreloader();
    setTimeout(() => {
      hidePreloader();
      setactiveShownTotal(activeShownTotal + commonPageSize);
    }, 300);
  };

  const cloneCampaign = async (item) => {
    let campaignObject = { ...item, uid: generateUID() };
    const result = await save(campaignObject);
    if (result.status) {
      showAlert({ type: "success", msg: "Campaign clone successfully!" });
      getCampaignsData();
    } else showAlert({ type: "error", msg: "Unable to clone campaign!" });
  };

  const getCampaignsData = async () => {
    const result = await fetchAll();
    if (result.status) {
      let tableData = result.data;
      settableData(tableData);
      setfilteredList(tableData);
      if (result.data?.length === 0)
        showAlert({ type: "error", msg: "No campaigns added yet!" });
    } else showAlert({ type: "error", msg: "No campaigns added yet!" });
  };

  const trashCancel = () => {
    setactiveItem(null);
    setshowTrashConfirm(false);
  };

  const trashCampaign = async () => {
    const result = await remove({ uid: activeItem.uid });
    if (result.status) {
      getCampaignsData();
      showAlert({ type: "success", msg: "Campaign deleted successfully!" });
      setactiveItem(null);
      setshowTrashConfirm(false);
    } else showAlert({ type: "error", msg: "Unable to delete campaign!" });
  };

  const getTableData = (filterData) => {
    let data = [];
    filterData.forEach((item) => {
      let e = {
        checkAction: (
          <span className="check-all">
            <span onClick={() => setcheckedAll(!checkedAll)}>
              {checkedAll ? (
                <i className="orange hi-check-circle"></i>
              ) : (
                <i className="hi-circle"></i>
              )}
            </span>
          </span>
        ),
        image: item.image ? (
          <Img
            alt={item.content}
            src={JSON.parse(item.image)[0]}
            style={{ maxHeight: 40, maxWidth: 40 }}
          />
        ) : (
          <p>{t("noImage")}</p>
        ),
        content: item.content,
        action: (
          <div className="action-bar">
            <Actor
              type="trash"
              onClick={() => {
                setactiveItem(item);
                setshowTrashConfirm(true);
              }}
            />
            <Actor
              type="edit"
              onClick={() =>
                navigateTo({ route: "/admin/campaign/edit/" + item.uid })
              }
            />
            <Actor type="copy" onClick={() => cloneCampaign(item)} />
          </div>
        ),
      };
      data.push(e);
    });
    return data;
  };

  const deleteCampaign = async (uid: string) => {
    const result = await remove({ uid });
    if (result.status) {
      getCampaignsData();
      showAlert({ type: "success", msg: "App deleted successfully!" });
      setactiveItem(null);
      getCampaignsData();
    } else showAlert({ type: "error", msg: "Unable to delete app!" });
  };

  const deleteChecked = () => {
    (checkedAll ? filteredList : checkedList).forEach((e) => {
      deleteCampaign(e.uid);
    });
    setcheckedList([]);
    setisMultipleDelete(false);
  };

  setTitle(t("campaignsList"), "admin");
  useEffect(() => {
    getCampaignsData();
  }, []);

  useEffect(() => {
    settableContent({
      headers: [
        {
          template: (
            <span
              className="check-all"
              onClick={() => {
                let newCheckedList = [];
                if (checkedAll) {
                  setcheckedAll(!checkedAll);
                  setcheckedList([]);
                } else {
                  filteredList.forEach((e) => newCheckedList.push(e.uid));
                  setcheckedAll(!checkedAll);
                  setcheckedList(newCheckedList);
                }
              }}
            >
              <CheckBox
                isChecked={
                  checkedAll ||
                  (checkedList.length === filteredList.length &&
                    filteredList.length !== 0)
                }
              />
            </span>
          ),
        },
        {
          label: t("image"),
          key: "image",
        },
        {
          label: "Content",
          key: "content",
        },
        {
          label: "Actions",
          key: "actions",
        },
      ],
      content: getTableData(tableData),
    });
  }, [filteredList, checkedAll, checkedList]);
  return {
    trackScrolling,
    checkedList,
    checkedAll,
    setisMultipleDelete,
    setshowTrashConfirm,
    tableContent,
    activeShownTotal,
    deleteChecked,
    trashCampaign,
    trashCancel,
    showTrashConfirm,
    isMultipleDelete,
  };
};
